// Credit pack SKUs matching the Edge Function
export type CreditPackSku = 'credits_10' | 'credits_50' | 'credits_100';

export interface CreditPackConfig {
  sku: CreditPackSku;
  name: string;
  credits: number;
  priceInCents: number;
  popular?: boolean;
  savings?: string;
}

// Credit pack configurations matching the Edge Function pricing
export const CREDIT_PACKS: CreditPackConfig[] = [
  {
    sku: 'credits_10',
    name: '10 Credits',
    credits: 10,
    priceInCents: 999,
  },
  {
    sku: 'credits_50',
    name: '50 Credits',
    credits: 50,
    priceInCents: 3999,
    popular: true,
    savings: 'Save 20%',
  },
  {
    sku: 'credits_100',
    name: '100 Credits',
    credits: 100,
    priceInCents: 6999,
    savings: 'Save 30%',
  },
];

export function formatCreditPrice(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}

export function getPricePerCredit(pack: CreditPackConfig): string {
  const pricePerCredit = pack.priceInCents / pack.credits / 100;
  return `$${pricePerCredit.toFixed(2)}`;
}

export function getCreditPackBySku(sku: CreditPackSku): CreditPackConfig | undefined {
  return CREDIT_PACKS.find((pack) => pack.sku === sku);
}
